/**
 * Created by kfyy035 on 2018/5/9.
 */
const collect = {
  state: {
    isCollect: false
  },
  mutations: {
    SET_ISCOLLECT: (state, isCollect) => {
      state.isCollect = isCollect
    }
  },
  actions: {
    setIsCollect({ commit }, isCollect) {
      return new Promise((resolve, reject) => {
        commit('SET_ISCOLLECT', isCollect)
        resolve()
      })
    }
  }
}
export default collect



// WEBPACK FOOTER //
// ./src/store/modules/collect.js